/* eslint-disable prettier/prettier */
import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import { ErrorMessage } from "formik";
import { ISelectListItem } from "../types";
import $ from "jquery";

interface IPropsType {
    label?: string,
    name: string,
    value: number,
    options: Array<ISelectListItem>,
    required: boolean,
    optionLabel?: string,
    tooltipText?: string,
    containerClass?: string,
    additionalClass?: string,
    errorMessage?: string,
    disabled: boolean
}

function select2(props: IPropsType, ref) {
    const [selectedValue, setSelectedValue] = useState(props.value);
    const [firstLoad, setFirstLoad] = useState(true);
    const [isSelected, setIsSelected] = useState(false);
    const [isValid, setIsValid] = useState(true);

    useEffect(() => {

        if (firstLoad) {
            $('select[name="' + props.name + '"]').niceSelect();
            $('select[name="' + props.name + '"]').change(function (e) {
                setSelectedValue(parseInt(this.value));

                if (this.value && this.value != "0") {
                    setIsSelected(true);
                }
                else {
                    setIsSelected(false);
                }
            });
            setFirstLoad(false);
        }
        else {
            $('select[name="' + props.name + '"]').niceSelect('update');
        }

        if (!props.options || props.options.length == 0) {
            setIsSelected(false);
        }
        else if (props.options.some(x => x.Selected)) {
            setIsSelected(true);
        }       

    }, [props.options]);

    useImperativeHandle(ref, () => ({

        validate() {
            setIsValid(true);
            console.log('select ' + props.name + ' validate selectedValue=', selectedValue);
            if (selectedValue == null || selectedValue == 0) {
                setIsValid(false);
                return false;
            }
            return true;
        },

        getData() {
            return (selectedValue === '' ? null : selectedValue);
        }
    }));

   /* useEffect(() => {
        if (!firstLoad) {
            props.onSetValue(props.name, selectedValue);
        }
    }, [selectedValue]); */

    return (
        <div className={props.containerClass + (isSelected ? ' selected-select customSelectWrapper' : 'customSelectWrapper')} style={props.disabled ? { pointerEvents: "none", opacity: "0.4" } : {}}>
            {props.label && <span className="inputName">{props.label}</span>}

            <select
                name={props.name}
                className={(!isValid && props.errorMessage ? "is-invalid " : "") + 'customSelect ' + props.additionalClass}
            >
                {props.optionLabel &&
                    <option value={null}>{props.optionLabel}</option>}
                {props.options && props.options.map(item =>
                    <option key={item.Value} value={item.Value} selected={props.value ? props.value.toString() == item.Value : false} disabled={item.Disabled}>{item.Text}</option>
                )}
            </select>
            {!isValid && props.errorMessage && <p className="errorMessage defaultDescription">{props.errorMessage}</p>}
        </div>
    );

}

export default select2 = forwardRef(select2);